import React from 'react';

const DeleteFileIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3332 4.24091L12.2589 3.16663L7.99984 7.42567L3.74079 3.16663L2.6665 4.24091L6.92555 8.49996L2.6665 12.759L3.74079 13.8333L7.99984 9.57424L12.2589 13.8333L13.3332 12.759L9.07412 8.49996L13.3332 4.24091Z" fill="#DA2C25" />
  </svg>
);

export default DeleteFileIcon;
